import { render, staticRenderFns } from "./KarmaCatalogueAdd.vue?vue&type=template&id=04a63a5e&"
import script from "./KarmaCatalogueAdd.vue?vue&type=script&lang=js&"
export * from "./KarmaCatalogueAdd.vue?vue&type=script&lang=js&"
import style0 from "./KarmaCatalogueAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports